<template>
  <div class="coupon">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="main">
      <div class="coupon-title">
        <span class="title-kicker">限时福利</span>
        <span class="title-main">游严选账号优惠券</span>
        <span class="title-sub">大额优惠券<span>免费领取</span></span>
      </div>
      <div class="wrapper">
        <div class="couponMargin">
          <div class="couponBorder" v-if="!receive_status == 0">
            <div class="left">
              <span class="amount-symbol">¥</span>
              <span class="discount">{{ couponInfo.discount_amount }}</span>
              <span class="limit"
                >满{{ couponInfo.use_amount_limit }}元可用</span
              >
            </div>
            <div class="right">
              <span class="name">{{ couponInfo.coupon_name }}</span>
              <span class="validate-time">{{ time }} 到期</span>
              <span class="use-range">{{ useRange }}可用</span>
            </div>
            <div class="recieveBtn" @click="receive">
              <span>立即领取</span>
            </div>
          </div>
          <div class="couponEmpty" v-else>
            <empty-state
              title="券已领完"
              description="请查看其他活动吧"
              icon="el-icon-tickets"
              :icon-size="52">
            </empty-state>
          </div>
        </div>
      </div>
    </div>
    <myDialog
      :show="realNameShow"
      title="领取成功"
      text="优惠券已放入“个人中心-我的优惠券”"
      :closeFun="
        () => {
          realNameShow = false;
        }
      "
    >
      <div slot="btn">
        <div class="btnGroup">
          <div class="btn cancelBtn" @click="realNameShow = false">取消</div>
          <div class="btn" @click="useNow">立即使用</div>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import { couponDetail, couponReceive } from "@/request/API";
import myDialog from "@/components/myDialog";
import EmptyState from "@/components/emptyState";

export default {
  name: "coupon",
  props: {},
  components: {
    breadcrumb,
    myDialog,
    EmptyState,
  },
  data() {
    return {
      breadcrumbList: [{ link: "coupon", name: "领取优惠券" }],
      couponInfo: {},
      receive_status: 1,
      realNameShow: false,
      hasCreated: true,
      receiveInfo: {
        receive_status: 1,
        receive_info: "",
      },
      coupon_channel: "",
    };
  },
  methods: {
    createMessage(text) {
      if (this.hasCreated) {
        this.hasCreated = false;
        let body = document.getElementsByTagName("body");
        let message = document.createElement("div");
        let style = {
          background: "rgba(0,0,0,0.7)",
          padding: "8px 10px",
          fontSize: "17px",
          borderRadius: "6px",
          position: "fixed",
          top: "50%",
          left: "calc(50% - 160px)",
          color: "white",
          width: "320px",
          textAlign: "center",
        };
        for (let k in style) {
          message.style[k] = style[k];
        }
        body[0].appendChild(message);
        clearTimeout(timer);
        var timer = setTimeout(() => {
          body[0].removeChild(message);
          this.hasCreated = true;
        }, 1500);
        message.innerHTML = text;
      }
    },
    receive() {
      if (localStorage.getItem('loginStatus') != 'true'){
        // this.$router.push('/login')
        this.$router.push({
          path: '/login',
          query: {
            coupon_id:this.couponInfo.coupon_id,
            coupon_channel:this.coupon_channel
          },
        })
      }
      couponReceive({
        coupon_id: this.couponInfo.coupon_id,
        coupon_channel:this.coupon_channel
      }).then((res) => {
        this.receiveInfo = res.data;
        // this.receive_status = res.data.receive_status;
        if (res.data.receive_status == 0) {
          this.createMessage(res.data.receive_info);
        } else {
          this.realNameShow = true;
        }
      });
    },
    useNow() {
      if (this.couponInfo.type == 3) {
        if (this.couponInfo.use_range == 1) {
          this.$router.push({ name: "AccountSell", params: {} });
        } else {
          this.$router.push({
            name: "AccountSell",
            params: { coupon: true, coupon_id: this.couponInfo.coupon_id },
          });
        }
      } else {
        if (this.couponInfo.use_range == 1) {
          this.$router.push({ name: "AllGame", params: {} });
        } else {
          this.$router.push({
            name: "AllGame",
            params: { coupon: true, coupon_id: this.couponInfo.coupon_id },
          });
        }
      }
    },
  },
  mounted() {
    let coupon_id = this.$route.query.id;
    this.coupon_channel = this.$route.query.coupon_channel ? this.$route.query.coupon_channel : this.$route.query.channel
    couponDetail({
      coupon_id,
    })
      .then((res) => {
        this.couponInfo = res.data.coupon_info;
        this.receive_status = res.data.receive_status;
      })
      .catch((res) => {
        this.createMessage(res.msg);
        this.receive_status = 0
      });
  },
  watch: {},
  computed: {
    time() {
      if (this.couponInfo.validity_type == 1) {
        return `${this.couponInfo.validity_num}天`;
      } else {
        return this.couponInfo.validity_end_time;
      }
    },
    useRange() {
      if (this.couponInfo.use_range == 1) {
        return "全部游戏账号";
      } else if (this.couponInfo.use_range == 2) {
        return "部分游戏";
      } else {
        return "部分账号商品";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .main {
    width: calc(1200px - 88px);
    min-height: 520px;
    padding: 56px 72px 72px;
    background: var(--bg-page, #F7F5F2);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .coupon-title {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .title-kicker {
        height: 26px;
        margin-bottom: 10px;
        padding: 0 14px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        color: var(--primary, #FF7A1A);
        background: var(--primary-soft, #FFF3E7);
        font-size: 13px;
        line-height: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 600;
      }

      .title-main {
        font-size: 34px;
        line-height: 46px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 700;
        color: var(--text-main, #111827);
      }

      .title-sub {
        margin-top: 6px;
        font-size: 18px;
        line-height: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);

        span {
          margin-left: 4px;
          color: var(--primary, #FF7A1A);
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 700;
        }
      }
    }

    .wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .couponMargin {
        width: 100%;
        min-height: 280px;
        padding: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

        .couponBorder {
          user-select: none;
          min-height: 156px;
          width: 560px;
          margin: 0;
          position: relative;
          display: flex;
          align-items: center;
          overflow: hidden;
          border: 1px solid rgba(255, 90, 31, 0.2);
          border-radius: 4px;
          background: linear-gradient(90deg, var(--primary-soft, #FCEDE5) 0, #FFFFFF 162px, #FFFFFF 100%);
          box-shadow: 0 12px 28px rgba(255, 122, 26, 0.12);
          transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;

          &:hover {
            border-color: rgba(255, 122, 26, 0.36);
            box-shadow: 0 16px 34px rgba(255, 122, 26, 0.16);
            transform: translateY(-2px);
          }

          &::before {
            width: 5px;
            align-self: stretch;
            background: var(--primary, #FF7A1A);
            content: "";
          }

          &::after {
            position: absolute;
            top: 50%;
            right: 160px;
            width: 1px;
            height: 104px;
            border-left: 1px dashed rgba(255, 122, 26, 0.28);
            transform: translateY(-50%);
            content: "";
          }

          .left {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 0 0 156px;
            min-width: 0;
            min-height: 120px;
            padding: 0 20px;
            position: relative;
            text-align: center;

            .amount-symbol {
              position: absolute;
              top: 34px;
              left: 36px;
              color: var(--primary, #FF7A1A);
              font-size: 16px;
              line-height: 20px;
              font-weight: 600;
            }

            .discount {
              max-width: 100%;
              font-size: 46px;
              color: var(--primary, #FF7A1A);
              font-weight: 700;
              line-height: 52px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .limit {
              max-width: 100%;
              margin-top: 4px;
              color: var(--text-muted, #9AA0AC);
              font-size: 12px;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            min-width: 0;
            min-height: 120px;
            padding: 24px 178px 24px 20px;

            .name {
              color: var(--text-main, #111827);
              font-size: 18px;
              line-height: 26px;
              font-weight: 600;
              max-width: 100%;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }

            .validate-time {
              color: var(--text-secondary, #5A5F6B);
              font-size: 13px;
              line-height: 20px;
              padding: 8px 0;
            }

            .use-range {
              color: var(--text-muted, #9AA0AC);
              font-size: 13px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .recieveBtn {
            width: 124px;
            height: 42px;
            border-radius: 3px;
            border: 1px solid var(--primary, #FF5A1F);
            background: var(--primary, #FF5A1F);
            color: #FFFFFF;
            font-size: 14px;
            line-height: 42px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
            right: 24px;
            position: absolute;
            top: 50%;
            padding: 0 18px;
            transform: translateY(-50%);
            box-shadow: 0 10px 20px rgba(255, 122, 26, 0.22);
            transition: transform .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease;

            span {
              position: relative;
              z-index: 1;
            }

            &::before {
              position: absolute;
              inset: 2px;
              border-radius: 2px;
              border: 1px solid rgba(255, 255, 255, 0.34);
              content: "";
            }

            &:hover {
              background: var(--primary-hover, #E84A12);
              box-shadow: 0 14px 24px rgba(255, 90, 31, 0.28);
            }

            &:active {
              transform: translateY(-50%) scale(.98);
              opacity: .92;
            }
          }
        }

        .couponEmpty {
          user-select: none;
          min-height: 180px;
          width: 560px;
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          /deep/ .empty-state__visual {
            color: var(--primary, #FF7A1A);
            background: var(--primary-soft, #FFF3E7);
          }

          /deep/ .empty-state__title {
            color: var(--text-main, #111827);
            font-weight: 500;
          }
        }
      }
    }
  }

  .btnGroup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    /deep/ .btn {
      width: 132px !important;
      height: 40px !important;
      margin: 0 !important;
      border: none;
      border-radius: 3px !important;
      font-size: 15px;
      line-height: 40px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: center;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      cursor: pointer;
      transition: box-shadow .2s ease, opacity .2s ease, color .2s ease, background .2s ease, border-color .2s ease;

      &:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 10px 22px rgba(255, 90, 31, 0.20);
        opacity: 1;
      }
    }

    .cancelBtn {
      border: 1.5px solid var(--bg-dark, #1A1D24) !important;
      background: transparent !important;
      color: var(--text-main, #1A1D24) !important;

      &:hover {
        color: var(--text-main, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8) !important;
        border-color: var(--bg-dark, #1A1D24) !important;
        box-shadow: none;
        opacity: 1;
      }
    }
  }
}
</style>
